import React from 'react';
import Icon from '../../../components/AppIcon';

const FeedbackPanel = ({ warnings, currentDevice }) => {
  const performanceMetrics = [
    { label: 'Скорость загрузки', value: 'Отлично', status: 'success', icon: 'Zap' },
    { label: 'Адаптивность', value: 'Оптимально', status: 'success', icon: 'Smartphone' },
    { label: 'SEO готовность', value: 'Хорошо', status: 'success', icon: 'Search' }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'success': return 'text-success';
      case 'warning': return 'text-warning';
      case 'error': return 'text-error';
      default: return 'text-text-secondary';
    }
  };

  return (
    <div className="bg-card border-t border-border px-4 md:px-6 py-3 md:py-4">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
        <div className="flex items-center gap-4 md:gap-6 flex-wrap">
          {performanceMetrics?.map((metric, index) => (
            <div key={index} className="flex items-center gap-2">
              <Icon 
                name={metric?.icon} 
                size={16} 
                className={getStatusColor(metric?.status)} 
              />
              <span className="caption text-text-secondary">{metric?.label}:</span>
              <span className={`caption font-medium ${getStatusColor(metric?.status)}`}>
                {metric?.value}
              </span>
            </div>
          ))}
        </div>

        {warnings?.length > 0 && (
          <div className="flex items-center gap-2 px-3 py-2 bg-warning/10 rounded-lg">
            <Icon name="AlertTriangle" size={16} className="text-warning" />
            <span className="caption text-warning font-medium">
              {warnings?.length} предупреждений
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedbackPanel;